/**
 * @generated SignedSource<<16354dbfb203486587724684a9b9313c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Header_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"src_issueTableHideDoneToggle_HideDoneItemsToggle_project" | "ui_issueTableGroupByDropdown_GroupByDropdown_project">;
  readonly " $fragmentType": "main_issueNavigator_Header_project";
};
export type main_issueNavigator_Header_project$key = {
  readonly " $data"?: main_issueNavigator_Header_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_Header_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_project"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_issueTableGroupByDropdown_GroupByDropdown_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "541121ab5814b34db1e36ace7c453c3f";

export default node;
